import { ImageHelper } from '../../../controls/ImageHelper/ImageHelper';
import { CTAButton } from '../../../controls/ButtonBase';
import { getBasePathName } from '../../../helpers/path';
import { useKioskState } from '../../../context/Kiosk/kiosk';
import { images as valuationImages } from '../../../assets/img/valuation';
import { useLocalization } from '../../../context/Localization/localization';
import { default as css } from '../index.module.scss';
import { GMButtonGroup } from '../../../controls/ButtonGroup';
import { GMRoundedIcon, GMSizedIcon } from '../../../controls/Icon';

export interface ValuationFullScreenProps {
    onReviewEquity: (review: boolean) => void;
    onSkip?: () => void;
}

export const ValuationFullScreen = (props: ValuationFullScreenProps) => {
    const {
        dealer: { valuationFullScreenImage: ValuationFullScreenImage },
    } = useKioskState();
    const src = valuationImages[getBasePathName(ValuationFullScreenImage) as keyof typeof valuationImages];
    const Localization = useLocalization();

    return (
        <div className={css.valuationImageWrapper}>
            <ImageHelper imageProps={{ src: src }} />
            <div className={css.valuationButtons}>
                <GMButtonGroup
                    alignment={'center'}
                    buttons={[
                        (
                            <CTAButton
                                styleType={'primary'}
                                onClick={() => props.onReviewEquity(true)}
                                title={Localization.ClickToConfirmEquityReview}
                                label={Localization.YesIWould}
                                kioskOptions={{ square: true }}
                                id={Localization.ClickToConfirmEquityReview}
                                ariaLabel={Localization.ClickToConfirmEquityReview}
                            />
                        ),
                        (
                            <CTAButton
                                styleType={'secondary'}
                                onClick={() => props.onReviewEquity(false)}
                                title={Localization.ClickToSkipEquityReview}
                                label={Localization.NoIWouldNot}
                                kioskOptions={{
                                    square: true,
                                    squareOptions: {
                                        roundedIcon: (
                                            <GMRoundedIcon
                                                themeType={'primary'}
                                                allowInvertedPrimary
                                                roundedBackgroundSize={'large'}
                                            >
                                                <GMSizedIcon iconSize={'custom'} iconType={'No'} />
                                            </GMRoundedIcon>
                                        ),
                                    },
                                }}
                                id={Localization.ClickToSkipEquityReview}
                                ariaLabel={Localization.ClickToSkipEquityReview}
                            />
                        ),
                    ]}
                />
            </div>
        </div>
    );
};